<!--
 * @Author: fengxiaojing
 * @Description: 分屏文件预览 可能存在的文档类型：svg, ht, pdf
-->
<template>
  <div class="w-full h-full file_preview position-relative" v-loading="fileLoading">
    <div class="file_preview_header" v-if="fileProps.fileType === 'pdf'"></div>
    <!-- 标题 -->
    <div
      class="fixed top-0 right-0 w-1/2 bg-[#000] h-30px leading-30px text-[#fff] text-14px"
      v-else-if="fileProps.fileType !== 'pdf'"
    >
      <span class="pl-10px">{{ fileProps.fileName }}</span>
    </div>
    <!-- svg,ht,pdf使用iframe嵌套 -->
    <iframe
      v-if="iframeFileType.includes(fileProps.fileType)"
      class="w-full h-full"
      :src="fileProps.fileUrl"
      @load="loadFile()"
      :id="fileProps.id"
    ></iframe>
    <!-- pdf预览 -->
    <div
      v-if="fileProps.fileType === 'pdf'"
      class="fixed top-0 right-0 w-1/2 bg-[#000] h-30px leading-30px text-[#fff] text-14px"
    >
      <span class="pl-10px">{{ fileProps.fileName }}</span>
      <div class="flex-row-center-center h-full">
        <span class="pl-10px mr-10px text-color-blue"
          >操作提示：Ctrl + 鼠标滚轮中键 可放大缩小</span
        >
        <!-- 二维标记、三维标记 -->
        <span class="">
          <template v-if="_.includes(modelMark, '三维标记')">
            <el-tooltip content="二维标记" placement="top" effect="dark" :open-delay="1000">
              <img
                src="@/views/docView/image/toolbar/modelMark_bule.png"
                class="mr-5px mark_btn"
                @click="captureImage('split')"
              />
            </el-tooltip>
          </template>
          <template v-if="_.includes(modelMark, '标记列表')">
            <el-tooltip content="标记列表" placement="top" effect="dark" :open-delay="1000">
              <img
                src="@/views/docView/image/toolbar/markList_bule.png"
                class="mr-5px mark_btn"
                @click="showMarkList('split')"
              />
            </el-tooltip>
          </template>
        </span>
      </div>
    </div>
    <!-- 图片预览 -->
    <img
      v-else-if="imgType.includes(fileProps.fileType)"
      id="mainImgDom"
      class="w-full !pt-1/3"
      :src="fileProps.fileUrl"
      alt
    />
    <!-- 视频 -->
    <div v-else-if="videoType.includes(fileProps.fileType)">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
        @play="onPlayerPlay($event)"
        @pause="onPlayerPause($event)"
        @ready="playerReadied($event)"
      ></video-player>
    </div>
    <!-- 标记列表弹框 -->
    <MarkerList
      v-if="isOpenMarkerDiaog"
      @closeComponent="isOpenMarkerDiaog = false"
      @showMarker="showMarker"
      :height="'500px'"
      :top="'66px'"
      :currentSplitFileId="fileProps.fileId"
    ></MarkerList>
  </div>
</template>
<script>
import { videoPlayer } from 'vue-video-player'
import MarkerList from './businessDialog/MarkerList'

export default {
  components: { videoPlayer, MarkerList },
  props: {
    /**
     * @description: 文件加载所需要的数据
     * @param {*} fileProps id: '',fileName: '',fileType: '', fileUrl: '', fileId: ''
     * @return {*}
     */

    fileProps: {
      type: Object,
      default: null,
    },
    tagCode: {
      type: String,
      default: '',
    },
    imgType: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      isOpenMarkerDiaog: false, // 是否打开标记列表弹框
      fileLoading: true,
      iframeFileType: ['svg', 'pdf', 'ht'],
      videoType: ['mp4', 'wmv', 'avi', 'mkv'],
      // 视频播放参数配置
      playerOptions: {
        height: '700',
        muted: false,
        preload: 'auto',
        language: 'zh-CN',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        aspectRatio: '16:9',
        sources: [
          {
            type: 'video/mp4',
            src: '',
          },
        ],
        fluid: true,
        poster: '',
      },
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
    }
  },
  computed: {
    modelMark() {
      const modelTool = _.find(this.systemParams, { parameterCode: 'modelTool' }) || {}
      if (!_.isEmpty(modelTool.parameterValue)) {
        const barList = modelTool.parameterValue.split(',')
        return barList
      }
      return []
    },
  },
  watch: {
    fileProps: {
      deep: true,
      immediate: true,
      handler(props) {
        // console.log(props, 'fileProps')
        if (this.imgType.includes(props.fileType)) {
          this.fileLoading = false
        }
        if (this.videoType.includes(props.fileType)) {
          this.playerOptions.sources[0].src = url
        }
      },
    },
  },
  mounted() {
    window.addEventListener('message', this.watchMsh)
  },
  methods: {
    /**
     * @description: 展示标记
     * @param {*} node 标记信息
     * @return {*}
     */
    showMarker(node) {
      this.$emit('showMarker', node)
    },
    // 二维标记列表
    async showMarkList(currentScreen) {
      this.isOpenMarkerDiaog = true
    },
    // 二维截屏
    captureImage(currentScreen) {
      this.$emit('captureImage', currentScreen)
    },
    loadFile() {
      this.fileLoading = false
      this.$emit('loadFile', {
        loadFileType: this.fileProps.fileType,
        status: true,
      })
      if (this.tagCode && this.fileProps.fileType === 'svg') {
        // svg加载时有5000ms的延迟
        setTimeout(() => {
          window.svgData[window.location.href].svgHotTrigger(this.tagCode)
        }, 5000)
      }
    },
    /**
     * @description: iframe文件内嵌的文件点击事件
     * @param {*} data
     * @return {*}
     */

    watchMsh(data) {
      // svg点击事件
      if (data.data.type === 'svgTrigger') {
        this.$emit('svgClick', data.data.code)
      }
    },
    // 视频播放相关
    onPlayerPlay(player) {
      // console.log('player', player)
    },
    onPlayerPause(player) {
      // console.log('player pause', player)
    },
    playerReadied(player) {
      player.currentTime(0)
    },
  },
}
</script>
<style lang="scss" scoped>

.file_preview {
  // background-color: #f6f8f9 !important;

  &_header {
    height: 6%;
    background: #4a4a4a;
  }
  &_content {
    height: 91%;
  }
  &_bottom {
    right: 0px;
    bottom: 0px;
    width: 100%;
    background: rgba(46, 107, 176, 0.3);
  }
}
.mark_btn {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.flex-row-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.fileTitle-box {
  // position: absolute;
  // top: 0;
  background-color: #fff;
  border: 1px solid #ddd;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.position-absolute {
  position: absolute;
}

</style>
